@if(isLocked()) {
    <div class="tw-absolute tw-inset-0 tw-bg-product-lock-overlay tw-backdrop-blur-[2px] tw-opacity-90 tw-z-[100] tw-flex tw-items-center tw-justify-center"
         (click)="onGotoProduct(product())">
        <div class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-bg-gray-500 tw-rounded-full">
            <cs-icon class="tw-w-[14px] tw-h-[17px] tw-text-gray-500" [iconName]="'lock-icon-white'" />
        </div>
    </div>
}

<div class="tw-flex tw-flex-col tw-px-4 tw-py-5 tw-basis-[50%]" [class]="{'tw-bg-gray-100': type() === DisplayType.PURPOSE_SUBTEXT_BANNER}">
    @if (purpose() && type() === DisplayType.PURPOSE_HEADER_BANNER) {
        <p class="tw-text-gray-750 tw-tracking-wider tw-uppercase tw-font-lexend tw-text-50 tw-leading-[18px] xs:tw-text-100 xs:tw-mb-1">{{purpose()}}</p>
    }
    <h2 class="tw-font-lexend tw-font-bold tw-mb-0.5 tw-text-300 tw-leading-[16.8px] xs:tw-text-400 xs:tw-leading-[19px] sm:tw-text-500 sm:tw-leading-[22px]"
        (click)="onGotoProduct(product())">
        {{ productTitle() }}
    </h2>
    @if (purpose() && type() === DisplayType.PURPOSE_SUBTEXT_BANNER) {
        <p class="tw-font-body tw-text-100 tw-leading-[14px] xs:tw-text-200 xs:tw-leading-[16px] tw-text-gray-500 tw-line-clamp-2">{{purpose()}}</p>
    }
    <div class="tw-flex-1"></div>

    <div class="tw-flex tw-items-center tw-gap-1 tw-font-lexend tw-mb-1"
         (click)="onGotoProduct(product())">
        <p class="tw-font-medium tw-text-gray-500 tw-line-through tw-text-100 tw-leading-[18px] xs:tw-text-200 xs:tw-leading-[18px]">
            ₹{{ product()?.mrp }}
        </p>
        <p class="tw-font-bold tw-text-orange-500 tw-text-300 tw-leading-[21px] xs:tw-text-400">
            ₹{{ product()?.price }}
        </p>
    </div>

    @if (productQuantity() === 0) {
        <button csButton
                size="small"
                (click)="addToCartAction(product(), image)"
                class="tw-min-w-fit tw-w-fit tw-px-10 tw-m-0">
            <span class="tw-text-300 tw-font-medium"
                  i18n="@@add">Add</span>
        </button>
    } @else {
        <div class="tw-h-8 tw-border tw-border-teal-600 tw-rounded-2 tw-flex tw-w-fit tw-items-center tw-text-200 tw-bg-white tw-text-teal-600 tw-font-lexend tw-font-semibold">
            <div class="tw-px-4 tw-flex">
                <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'minus'" (click)="removeFromCartAction(product())"></cs-icon>
            </div>
            <span class="tw-px-2">{{ productQuantity() }}</span>
            <div class="tw-px-4 tw-flex">
                <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'plus'" (click)="addToCartAction(product(), image)"></cs-icon>
            </div>
        </div>
    }
</div>
<div class="tw-overflow-hidden tw-flex tw-items-center tw-justify-center tw-basis-[50%] tw-bg-gray-200"
     (click)="onGotoProduct(product())">
    <img class="tw-h-full tw-w-auto tw-object-cover tw-object-center"
         alt="Product"
         #image=""
         [src]="productImage()" />
</div>
